import { useCallback } from 'react'

// utils
import {
  getDishContract,
  getExchangeNFTContract,
  approveERC721,
  getExchangeEggNFTContract,
  getPetEggNftContract,
  getExchangeArtworkNFTContract,
  getArtworkNftContract,
  getExchangeBinanceNftContract,
  getBinanceNftContract,
  getWeaponNFTContract,
  getExchangeWeaponNFTContract,
  getExchangeBakeryArtworkNFTContract,
  getBakeryArtworkNFTContract,
  getPetNftContract,
  getExchangePetNftContract,
  getBidDigitalArtworkNFTContract,
  getBidBakeryArtworkNFTContract,
  getBidBinanceNftContract,
  getBidPetNftContract,
  getBidWeaponNFTContract,
  getBidPetEggNFTContract,
  getBidDishNFTContract,
  getExchangeBakeryArtwork2NFTContract,
  getBakeryArtwork2NFTContract,
  getBidBakeryArtwork2NFTContract,
  getExchangeBakeryArtwork3NFTContract,
  getBakeryArtwork3NFTContract,
  getBidBakeryArtwork3NFTContract,
  getExchangeSeascapeNFTContract,
  getSeascapeNFTContract,
  getBidSeascapeNftContract,
  getOneInchBakeNFTContract,
  getExchangeOneInchBakeNFTContract,
  getBidOneInchBakeNFTContract,
  getBakerySoccerContract,
  getExchangeBakerySoccerContract,
  getBidBakerySoccerContract,
  getTokocryptoNFTContract,
  getExchangeTokocryptoNFTContract,
  getBidTokocryptoNftContract
} from '../../sushi/utils'

// hooks
import useYam from '../bakery/useYam'
import { useActiveWeb3React } from '..'
import { useMarketLevel } from '../../state/market/hooks'

export const GETEXCHANGE = 'GETEXCHANGE'
export const GETEGGEXCHANGE = 'GETEGGEXCHANGE'
export const GETARTWORKEXCHANGE = 'GETARTWORKEXCHANGE'
export const GETBINANCEEXCHANGE = 'GETBINANCEEXCHANGE'
export const GETWEAPONEXCHANGE = 'GETWEAPONEXCHANGE'
export const GETBAKERYARTWORKEXCHANGE = 'GETBAKERYARTWORKEXCHANGE'
export const GETPETEXCHANGE = 'GETPETEXCHANGE'
export const GETMUSKDOGEEXCHANGE = 'GETMUSKDOGEEXCHANGE'
export const GETMEMEEXCHANGE = 'GETMEMEEXCHANGE'
export const GETSEASCAPEEXCHANGE = 'GETSEASCAPEEXCHANGE'
export const GETONEINCHSEXCHANGE = 'GETONEINCHSEXCHANGE'
export const GETBAKERYSOCCEREXCHANGE = 'GETBAKERYSOCCEREXCHANGE'
export const GETTKONFTEXCHANGE = 'GETTKONFTEXCHANGE'

const useApproveERC721 = (tokenId: string, type: string) => {
  const { account } = useActiveWeb3React()
  const sushi = useYam()
  const level = useMarketLevel()
  let erc721Contract = getDishContract(sushi)
  let contract = ''
  switch (type) {
    case GETBAKERYSOCCEREXCHANGE:
      erc721Contract = getBakerySoccerContract(sushi)
      if (level === 'v1') {
        contract = getExchangeBakerySoccerContract(sushi)
      } else {
        contract = getBidBakerySoccerContract(sushi)
      }
      break
    case GETONEINCHSEXCHANGE:
      erc721Contract = getOneInchBakeNFTContract(sushi)
      if (level === 'v1') {
        contract = getExchangeOneInchBakeNFTContract(sushi)
      } else {
        contract = getBidOneInchBakeNFTContract(sushi)
      }
      break
    case GETSEASCAPEEXCHANGE:
      erc721Contract = getSeascapeNFTContract(sushi)
      if (level === 'v1') {
        contract = getExchangeSeascapeNFTContract(sushi)
      } else {
        contract = getBidSeascapeNftContract(sushi)
      }
      break
    case GETMEMEEXCHANGE:
      erc721Contract = getBakeryArtwork3NFTContract(sushi)
      if (level === 'v1') {
        contract = getExchangeBakeryArtwork3NFTContract(sushi)
      } else {
        contract = getBidBakeryArtwork3NFTContract(sushi)
      }
      break
    case GETMUSKDOGEEXCHANGE:
      erc721Contract = getBakeryArtwork2NFTContract(sushi)
      if (level === 'v1') {
        contract = getExchangeBakeryArtwork2NFTContract(sushi)
      } else {
        contract = getBidBakeryArtwork2NFTContract(sushi)
      }
      break
    case GETEXCHANGE:
      if (level === 'v1') {
        contract = getExchangeNFTContract(sushi)
      } else {
        contract = getBidDishNFTContract(sushi)
      }
      break
    case GETEGGEXCHANGE:
      erc721Contract = getPetEggNftContract(sushi)
      if (level === 'v1') {
        contract = getExchangeEggNFTContract(sushi)
      } else {
        contract = getBidPetEggNFTContract(sushi)
      }
      break
    case GETARTWORKEXCHANGE:
      erc721Contract = getArtworkNftContract(sushi)
      if (level === 'v1') {
        contract = getExchangeArtworkNFTContract(sushi)
      } else {
        contract = getBidDigitalArtworkNFTContract(sushi)
      }
      break
    case GETBINANCEEXCHANGE:
      erc721Contract = getBinanceNftContract(sushi)
      if (level === 'v1') {
        contract = getExchangeBinanceNftContract(sushi)
      } else {
        contract = getBidBinanceNftContract(sushi)
      }
      break
    case GETWEAPONEXCHANGE:
      erc721Contract = getWeaponNFTContract(sushi)
      if (level === 'v1') {
        contract = getExchangeWeaponNFTContract(sushi)
      } else {
        contract = getBidWeaponNFTContract(sushi)
      }
      break
    case GETBAKERYARTWORKEXCHANGE:
      erc721Contract = getBakeryArtworkNFTContract(sushi)
      if (level === 'v1') {
        contract = getExchangeBakeryArtworkNFTContract(sushi)
      } else {
        contract = getBidBakeryArtworkNFTContract(sushi)
      }
      break
    case GETPETEXCHANGE:
      erc721Contract = getPetNftContract(sushi)
      if (level === 'v1') {
        contract = getExchangePetNftContract(sushi)
      } else {
        contract = getBidPetNftContract(sushi)
      }
      break
    case GETTKONFTEXCHANGE:
      erc721Contract = getTokocryptoNFTContract(sushi)
      if (level === 'v1') {
        contract = getExchangeTokocryptoNFTContract(sushi)
      } else {
        contract = getBidTokocryptoNftContract(sushi)
      }
      break
  }
  const handleApprove = useCallback(async () => {
    try {
      const tx = await approveERC721(erc721Contract, contract, tokenId, account)
      return tx
    } catch (e) {
      return false
    }
  }, [account, erc721Contract, contract, tokenId])

  return handleApprove
}

export default useApproveERC721
